<template>
  <div class="ProductCenter clear">
    <div class="indexMain">
      <div class="title">
        <div class="t_cn">产品中心</div>
        <div class="t_en">PRODUCT</div>
      </div>
    </div>
    <div class="cont">
      <div class="indexMain ProductCont clear">
        <div
          class="item_Product"
          v-for="(item, index) in ProductList"
          :key="index"
        >
          <router-link :to="'/product-detail?id=' + item.id">
            <div class="item_box">
              <img
                class="product_img"
                :src="item.productImg"
                :alt="item.productInfo"
              />
              <div class="product_info">{{ item.productInfo }}</div>
              <div class="product_cont">
                {{ item.productCont }}
              </div>

              <div class="btn-more">
                <span>查看详情</span>
                <i class="jiantou_right"></i>
              </div>
            </div>
          </router-link>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  data() {
    return {
      ProductList: [
        {
          id: 0,
          productImg: require("../../assets/images/index/product_img1.png"),
          productInfo: "广达牌樟脑",
          productCont:
            "本品为白色结晶性粉末或无色半透明的硬块，味初辛、后清凉；主要用作医药原料，如皮肤刺激药、生产樟脑磺酸钠。",
        },
        {
          id: 1,
          productImg: require("../../assets/images/index/product_img2.png"),
          productInfo: "白雪牌冰片",
          productCont:
            "本品为无色透明或半透明的片状松脆结晶；气清香，味辛、凉；在中医药中用于治疗热病神昏、惊厥、中风痰厥、气郁暴厥、中恶昏迷、目赤、口疮、咽喉肿痛、耳道流脓等症状，冰片还是良好的食品、日常护理品和香精香料的原料。",
        },
        {
          id: 4,
          productImg: require("../../assets/images/index/product_img3.png"),
          productInfo: "三春牌醋酸钠",
          productCont:
            "本产品为无色或白色晶体，暴露于潮湿空气中易潮解，于干燥空气中易风化。主要用于印染工业、医药、照相、电镀、化学试剂及有机合成的生产等。",
        },
      ],
    };
  },
};
</script>

<style lang="scss" scoped>
.ProductCenter {
  position: relative;
  overflow: hidden;
  .cont {
    height: 27.86vw;
    background: url("../../assets/images/index/ProductBg.png") center no-repeat;
    background-size: 100%;
    .ProductCont {
      height: 100%;
      .item_Product {
        float: left;
        width: 33.3%;
        height: 100%;
        cursor: pointer;
        box-sizing: border-box;
        padding: 1.25vw;
        background: rgba($color: #000000, $alpha: 0.4);
        position: relative;
        &:hover {
          background-color: #83bb26;
          .item_box {
            border: 0.05vw solid #ffffff;
            .btn-more {
              span {
                color: #ffffff;
              }
              .jiantou_right {
                background: url("../../assets/images/index/jisntou_right_on.png")
                  no-repeat;
                background-size: 100%;
              }
            }
          }
        }
        &::before {
          content: "";
          width: 0.05vw;
          height: 20.83vw;
          display: block;
          background-color: #efefef;
          opacity: 0.2;
          position: absolute;
          right: 0;
          top: 3.54vw;
        }
        .item_box {
          position: relative;
          padding: 1.56vw 2.6vw;
          box-sizing: border-box;
          width: 100%;
          height: 25.42vw;
          border: 0.05vw solid transparent;
          transition: 0.3s ease-in-out;
          .product_img {
            display: block;
            width: 6.25vw;
            margin: 0 auto;
          }
          .product_info {
            font-size: 1.25vw;
            line-height: 2.34vw;
            color: #ffffff;
            text-align: center;
            padding: 2.08vw 0 0.73vw 0;
            position: relative;
            &::before {
              content: "";
              display: block;
              width: 3.13vw;
              height: 0.21vw;
              background-color: #ffffff;
              position: absolute;
              bottom: 0;
              left: 50%;
              margin: 0 0 0 -1.56vw;
            }
          }
          .product_cont {
            max-height: 10.94vw;
            display: -webkit-box;
            text-overflow: ellipsis; /*可以用来多行文本的情况下，用省略号“…”隐藏超出范围的文本 。*/
            -webkit-box-orient: vertical;
            -webkit-line-clamp: 6;
            overflow: hidden;
            padding: 1.56vw 0 0 0;
            font-size: 0.83vw;
            line-height: 1.56vw;
            color: #ffffff;
          }
          .btn-more {
            width: 100%;
            text-align: center;
            margin: 2.08vw 0 0 0;
            position: absolute;
            bottom: 1.56vw;
            left: 0;
            cursor: pointer;
            span {
              font-size: 0.94vw;
              letter-spacing: 0.05vw;
              color: #89c61d;
              padding: 0 0.31vw 0 0;
            }
            .jiantou_right {
              display: inline-block;
              width: 1.98vw;
              height: 0.52vw;
              background: url("../../assets/images/index/jisntou_right.png")
                no-repeat;
              background-size: 100%;
            }
          }
        }
      }
    }
  }
}
@media (min-width: 1920px) {
  .ProductCenter {
    position: relative;
    overflow: hidden;
    .cont {
      height: 535px;
      background: url("../../assets/images/index/ProductBg.png") center
        no-repeat;
      background-size: 100%;
      .ProductCont {
        height: 100%;
        .item_Product {
          float: left;
          width: 33.3%;
          height: 100%;
          cursor: pointer;
          box-sizing: border-box;
          padding: 24px;
          background: rgba($color: #000000, $alpha: 0.4);
          &:hover {
            background-color: #83bb26;
            .item_box {
              border: 1px solid #ffffff;
              .btn-more {
                span {
                  color: #ffffff;
                }
                .jiantou_right {
                  background: url("../../assets/images/index/jisntou_right_on.png")
                    no-repeat;
                  background-size: 100%;
                }
              }
            }
          }
          &::before {
            content: "";
            width: 1px;
            height: 400px;
            display: block;
            background-color: #efefef;
            opacity: 0.2;
            position: absolute;
            right: 0;
            top: 68px;
          }
          .item_box {
            position: relative;
            padding: 30px 50px;
            box-sizing: border-box;
            width: 100%;
            height: 488px;
            border: 1px solid transparent;
            transition: 0.3s ease-in-out;
            .product_img {
              display: block;
              width: 120px;
              margin: 0 auto;
            }
            .product_info {
              font-size: 24px;
              line-height: 45px;
              color: #ffffff;
              text-align: center;
              padding: 40px 0 14px 0;
              position: relative;
              &::before {
                content: "";
                display: block;
                width: 60px;
                height: 4px;
                background-color: #ffffff;
                position: absolute;
                bottom: 0;
                left: 50%;
                margin: 0 0 0 -30px;
              }
            }
            .product_cont {
              max-height: 210px;
              display: -webkit-box;
              text-overflow: ellipsis; /*可以用来多行文本的情况下，用省略号“…”隐藏超出范围的文本 。*/
              -webkit-box-orient: vertical;
              -webkit-line-clamp: 6;
              overflow: hidden;
              padding: 30px 0 0 0;
              font-size: 16px;
              line-height: 30px;
              color: #ffffff;
            }
            .btn-more {
              width: 100%;
              text-align: center;
              margin: 40px 0 0 0;
              position: absolute;
              bottom: 30px;
              left: 0;
              cursor: pointer;
              span {
                font-size: 18px;
                letter-spacing: 1px;
                color: #89c61d;
                padding: 0 6px 0 0;
              }
              .jiantou_right {
                display: inline-block;
                width: 38px;
                height: 10px;
                background: url("../../assets/images/index/jisntou_right.png")
                  no-repeat;
                background-size: 100%;
              }
            }
          }
        }
      }
    }
  }
}
</style>